// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AccordionsBlock__block{border:1px solid #e5e5e5;display:block;margin-bottom:1rem;padding:1.375rem;text-align:center}@media(hover:hover){.AccordionsBlock__block:hover .AccordionsBlock__subtitle{-webkit-text-decoration:none;text-decoration:none}}.AccordionsBlock__title{font-size:1.125rem}.AccordionsBlock__subtitle{color:#7cb342;font-weight:700;-webkit-text-decoration:underline;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
